import {
    FETCH_MERCHANTS_LOADING,
    FETCH_MERCHANTS_SUCCESS,
    FETCH_MERCHANTS_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    merchants: [],
    totalElements: 0,
    totalPages: 0,
    error: null,
  };
  
  export default function recurringPlanMerchantReducer(state = initialState, action: any) {
    switch (action.type) {
      case FETCH_MERCHANTS_LOADING:
        return { ...state, loading: true, error: null };
  
      case FETCH_MERCHANTS_SUCCESS:
        return {
          ...state,
          loading: false,
          merchants: action.payload.merchants,
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          error: null,
        };
  
      case FETCH_MERCHANTS_FAILED:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  }
  